import React, {useEffect, useRef, useState} from 'react';

import CardHeader from '../../components/common/card-header/CardHeader';
import {Card, FlexItem, FlexLayout, Spinner, StackLayout, Text} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import OnlineProfileRegistrationAuthenticateForm from './OnlineProfileRegistrationAuthenticateForm';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {customerServiceLink} from '../../common/ApiUtils';
import {useLocation, useNavigate} from "react-router";


function OnlineProfileRegistrationAuthenticate() {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const mainRef = useRef(null);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.step1.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== Constants.login) {
      navigate('/');
    }
  }, [intl,navigate,location]);

  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("The information you provided is not correct. Please try again in 30 minutes.");
  const[isLoading, setIsLoading] = useState(false);


  const showErrorOnPage = (error) => {
    setErrorMessage(error);
    setHasError(true);
  }

  return (
    <main ref={mainRef} role="main" aria-label="Online Profile Registration Authenticate" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {isLoading ? (
            <FlexItem className="spinner-wrapper">
              <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
            </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
              <div>
                <CardAlert status={"error"} setHasError={setHasError}>{errorMessage}</CardAlert>
              </div>
            </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={2}>
                <CardHeader heading={Constants.onlineProfileRegistrationTitle} subheading={Constants.onlineProfileRegistrationStep1Title}
                            style={{maxWidth: "24.5rem"}} />

                <StepTracker label1={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step1'})} step1="active"
                             label2={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step2'})} step2="pending"
                             label3={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step3'})} step3="pending" />
                <FlexItem>
                  <Text>
                    {Constants.onlineProfileRegistrationStep1InstructionalText(customerServiceLink)}
                  </Text>
                </FlexItem>
                <OnlineProfileRegistrationAuthenticateForm
                  showErrorOnPage={showErrorOnPage}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  setHasError={setHasError}
                />
              </StackLayout>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default OnlineProfileRegistrationAuthenticate;